export default __webpack_public_path__ + "static/CTTW UW-8c2ea8888f0bfdcd12be67c6df725581.png";